import { render, staticRenderFns } from "./RoomEditor.vue?vue&type=template&id=251ec68f&"
import script from "./RoomEditor.vue?vue&type=script&lang=js&"
export * from "./RoomEditor.vue?vue&type=script&lang=js&"
import style0 from "./RoomEditor.vue?vue&type=style&index=0&id=251ec68f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports